import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js'
import { useEffect, useState } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextField from '../../FormLegacy/FormFieldsV2/TextField'
import { stripeElementOptions } from '../../CreditCardContent/helpers'

const CreditCardInfoForm = ({ onChange }) => {
  const { t } = useTranslation(['reservations'])
  const stripeElementsOptions = {
    style: {
      ...stripeElementOptions.style,
      base: {
        ...stripeElementOptions.style.base,
        fontWeight: 500,
        fontSize: '15px',
        padding: '10px 16px',
        backgroundColor: 'rgba(249, 248, 248, 1)',
        '::placeholder': {
          fontSize: '14px',
          color: '#3c3c3c',
          fontWeight: 500,
        },
      },
    },
  }

  const [cardData, setCardData] = useState({
    cardNumber: false,
    cardCvc: false,
    cardExpiry: false,
    cardOwner: '',
  })
  const [cardOwnerError, setCardOwnerError] = useState('')

  const handleCardCredentialsChanges = (event) => {
    if (event.complete) {
      setCardData({ ...cardData, [event.elementType]: true })
    } else {
      setCardData({ ...cardData, [event.elementType]: false })
    }
  }

  const handleCardOwnerChange = (cardOwner) => {
    setCardData({ ...cardData, cardOwner: cardOwner || '' })
    if (!cardOwner) {
      setCardOwnerError(t('reservations:validation.required'))
    } else {
      setCardOwnerError()
    }
  }

  useEffect(() => {
    onChange(cardData)
  }, [onChange, cardData])

  return (
    <div className="rows" style={{ width: '100%' }}>
      <div className={'column is-12'} style={{ padding: '12px 0' }}>
        <div className="add-guest-form__input-label">
          {t('reservations:creditCardInfoForm.cardholderName')}
        </div>
        <TextField
          name={'cardholderName'}
          placeholder={t('reservations:creditCardInfoForm.cardholderNamePlaceholder')}
          value={cardData.cardOwner}
          isError={!!cardOwnerError}
          errorLabel={cardOwnerError}
          onChange={(e) => handleCardOwnerChange(e.target.value)}
          style={{ boxShadow: 'none' }}
        />
      </div>
      <div className={'column is-12'} style={{ padding: '8px 0' }}>
        <div className="add-guest-form__input-label">
          {t('reservations:creditCardInfoForm.cardNumber')}
        </div>
        <div className="add-guest-form__stripe-element-wrapper">
          <CardNumberElement
            id="card-number-element"
            options={{
              ...stripeElementsOptions,
              placeholder: t('reservations:creditCardInfoForm.cardNumberPlaceholder'),
            }}
            onChange={(event) => handleCardCredentialsChanges(event)}
          />
        </div>
      </div>
      <div className="add-guest-form__expiration-cvv">
        <div className={'column is-8'} style={{ padding: '12px 0' }}>
          <div className="add-guest-form__input-label">
            {t('reservations:creditCardInfoForm.expirationDate')}
          </div>
          <div className="add-guest-form__stripe-element-wrapper">
            <CardExpiryElement
              id="card-expiry-element"
              options={{ ...stripeElementsOptions, placeholder: 'MM/YY' }}
              onChange={(event) => handleCardCredentialsChanges(event)}
            />
          </div>
        </div>
        <div className={'column is-4'} style={{ padding: '12px 0 12px 24px' }}>
          <div className="add-guest-form__input-label">
            {t('reservations:creditCardInfoForm.cvc')}
          </div>
          <div className="add-guest-form__stripe-element-wrapper">
            <CardCvcElement
              id="card-cvc-element"
              options={{ ...stripeElementsOptions, placeholder: '***' }}
              onChange={(event) => handleCardCredentialsChanges(event)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

CreditCardInfoForm.propTypes = {
  onChange: PropTypes.func,
}

export default CreditCardInfoForm
